import { useEffect, useState } from "react";
import { Volume2, VolumeX } from "lucide-react";
import { startAmbience, stopAmbience, ambienceOn, playConfirm } from "../lib/sounds";

// Floating ambience toggle — wash sounds only ever start from a user tap (autoplay-safe).
export default function SoundToggle() {
  const [on, setOn] = useState(false);
  useEffect(() => setOn(ambienceOn()), []);
  const toggle = () => {
    if (on) {
      stopAmbience();
      setOn(false);
    } else {
      startAmbience();
      setOn(true);
    }
  };
  return (
    <button
      onClick={toggle}
      aria-label={on ? "Turn car-wash sounds off" : "Turn car-wash sounds on"}
      title={on ? "Wash sounds on" : "Wash sounds off"}
      className={`fixed bottom-24 left-4 z-40 flex h-11 w-11 items-center justify-center rounded-full border backdrop-blur transition-all lg:bottom-6 ${
        on
          ? "border-carza/50 bg-carza/90 text-white shadow-[0_12px_30px_-10px_rgba(109,61,245,0.7)]"
          : "border-white/15 bg-white/[0.06] text-mist hover:border-carza/40 hover:text-paper"
      }`}
      data-testid="sound-toggle-btn"
    >
      {on ? <Volume2 size={17} /> : <VolumeX size={17} />}
    </button>
  );
}

// Renders nothing — plays the spray swoosh when a success screen mounts.
export function SuccessSound() {
  useEffect(() => {
    playConfirm();
  }, []);
  return null;
}